import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineProFirstReplyInputView のスタイル
 */
export const hotlineProFirstReplyInputViewStyle = tv({
    slots: {
        commentText: ['!text-base'],
        fieldWrap: ['flex flex-col gap-32', 'pt-28 pb-32 px-16 lg:p-32'],
    },
});
